import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PortfolioCharacteristics from './PortfolioCharacteristics.jsx'
import PortfolioTopHoldings from './PortfolioTopHoldings.jsx'
import PortfolioTopHoldingsETF from './PortfolioTopHoldingsETF.jsx'
import FullHoldingsDetails from '../../../FullHoldings/FullHoldingsDetails.jsx'
import PortfolioTopBaseComponent from './PortfolioTopBaseComponent.jsx'
import PortfolioBarChart from './PortfolioBarChart.jsx'
import { swapIndexPercentValue, isPresented } from '../../Helpers/FundUtility'
import { ETF_FUND, ETF_INDEX_FUND } from '../../Helpers/FundTypes.js'
import DataNotAvailable from '../../Helpers/DataNotAvailable.js'
import ErrorBoundary from '../Performance/ErrorBoundary.jsx'

class PortfolioDetails extends Component {
  getFullHoldingDetailData(fullHoldings) {
    const fullHoldingsData =
      fullHoldings && fullHoldings.value && fullHoldings.value.holdingDetail
    if (
      fullHoldingsData &&
      fullHoldingsData.fullHoldings &&
      fullHoldingsData.fullHoldings.length > 0
    ) {
      return fullHoldingsData
    }
    return null
  }

  render() {
    const { fund, fullHoldings } = this.props
    const isEtfIndex = fund.fundGroup === ETF_INDEX_FUND

    let showPortfolioData = false

    const fullHoldingDetail = this.getFullHoldingDetailData(fullHoldings)
    const hasTopHoldingsDetailsValue =
      fund.topHoldingDetail &&
      fund.topHoldingDetail.topHoldings &&
      fund.topHoldingDetail.topHoldings.length > 0
    const hasEtfTopHoldingDetailsValue =
      fund.etfHoldingDetail &&
      fund.etfHoldingDetail.etfHoldings &&
      fund.etfHoldingDetail.etfHoldings.length > 0

    if (isEtfIndex) {
      if (fund.topCountryDetail) {
        swapIndexPercentValue(fund.topCountryDetail.topCountries)
      }

      if (fund.topSectorDetail) {
        swapIndexPercentValue(
          fund.topSectorDetail.topSectors,
          'fundWeightPercent'
        )
      }

      if (fund.topTenComponentDetail) {
        swapIndexPercentValue(fund.topTenComponentDetail.topComponents)
      }
    }

    // if at least 1 statement is true, show portfolio section
    if (
      (isPresented(fund, 'portfolioCharsDetail') &&
        fund.portfolioCharsDetail) ||
      (isPresented(fund, 'etfHoldingDetail') && hasEtfTopHoldingDetailsValue) ||
      (isPresented(fund, 'topHoldingDetail') &&
        fund.fundGroup !== ETF_FUND &&
        hasTopHoldingsDetailsValue) ||
      fullHoldingDetail ||
      (isPresented(fund, 'topSectorDetail') && fund.topSectorDetail) ||
      (isPresented(fund, 'assetMixDetails') && fund.assetMixDetails) ||
      (isPresented(fund, 'topEquitySectorDetail') &&
        fund.topEquitySectorDetail) ||
      (isPresented(fund, 'topCountryDetail') && fund.topCountryDetail) ||
      fund.topTenComponentDetail ||
      (isPresented(fund, 'topIndustryDetail') && fund.topIndustryDetail) ||
      (isPresented(fund, 'assetAllocationDetail') &&
        fund.assetAllocationDetail) ||
      (isPresented(fund, 'topCurrencyDetail') && fund.topCurrencyDetail) ||
      (isPresented(fund, 'topBondSectorDetail') && fund.topBondSectorDetail) ||
      (isPresented(fund, 'creditRatingDetail') &&
        fund.creditRatingDetail &&
        fund.creditRatings) ||
      (isPresented(fund, 'averageLifeDistrDetail') &&
        fund.averageLifeDistributionDetail)
    ) {
      showPortfolioData = true
    }

    return (
      <section
        className="section-content u-adel-reset"
        data-section-content="portfolio-details"
        id="portfolio-details"
      >
        <div className="u-sizeConstrained">
          <hr className="Rule Rule--thin Module-divider" role="presentation" />
          <div className="u-paddingVert12gu">
            <h2>Portfolio</h2>
            {!showPortfolioData ? (
              <DataNotAvailable />
            ) : (
              <>
                {isPresented(fund, 'portfolioCharsDetail') &&
                  fund.portfolioCharsDetail && (
                    <PortfolioCharacteristics
                      portfolioCharsDetails={fund.portfolioCharsDetail}
                      fundGroup={fund.fundGroup}
                    />
                  )}

                {isPresented(fund, 'etfHoldingDetail') &&
                  fund.etfHoldingDetail && (
                    <PortfolioTopHoldingsETF
                      etfHoldingDetail={fund.etfHoldingDetail}
                      fund={fund}
                    />
                  )}

                {isPresented(fund, 'topHoldingDetail') &&
                  fund.fundGroup !== ETF_FUND &&
                  fund.topHoldingDetail &&
                  hasTopHoldingsDetailsValue && (
                    <ErrorBoundary
                      message="Top Holdings information is currently unavailable due to a technical issue. Please try again later."
                      title="Top Holdings"
                    >
                      <PortfolioTopHoldings
                        topHoldingDetail={fund.topHoldingDetail}
                        fund={fund}
                      />
                    </ErrorBoundary>
                  )}

                {fullHoldingDetail && (
                  <FullHoldingsDetails
                    fullHoldingDetail={fullHoldingDetail}
                    isFromDetails={true}
                    fundGroup={fund.fundGroup}
                    fund={fund}
                  />
                )}

                {isPresented(fund, 'topSectorDetail') &&
                  fund.topSectorDetail && (
                    <PortfolioTopBaseComponent
                      meta={{
                        topLevelId: 'top-sectors',
                        sectionLabel: fund.topSectorDetail.sectorsLabel,
                        firstHeading: 'Sector',
                        secondHeading: isEtfIndex ? 'Weight (%)' : 'Fund',
                        indexHeading: fund.topSectorDetail.indexName,
                        pieChartTableHeader: isEtfIndex
                          ? 'Sector Weighting (%)'
                          : 'Fund Weighting (%)',
                        pieChartPrefix: `The top sectors for this ${
                          isEtfIndex ? 'index' : 'fund'
                        } are`,
                        asOfDate: fund.topSectorDetail.sectorsAsOfDate,
                        details: 'topSectors',
                      }}
                      fund={fund.topSectorDetail}
                    />
                  )}

                {isPresented(fund, 'assetMixDetails') &&
                  fund.assetMixDetails && (
                    <PortfolioTopBaseComponent
                      meta={{
                        topLevelId: 'asset-mix-0',
                        sectionLabel: 'Asset Mix (%)',
                        firstHeading: 'Allocation Type',
                        secondHeading: 'Allocation %',
                        indexHeading: '',
                        pieChartTableHeader: 'Allocation Weighting (%)',
                        pieChartPrefix: '',
                        asOfDate: fund.assetMixDetails.asOfDate,
                        details: 'assetMixInfo',
                      }}
                      showDivider={false}
                      fund={fund.assetMixDetails}
                      key={fund.fundName}
                      index={0}
                    />
                  )}

                {isPresented(fund, 'topEquitySectorDetail') &&
                  fund.topEquitySectorDetail && (
                    <PortfolioTopBaseComponent
                      meta={{
                        topLevelId: 'top-equity-sectors',
                        sectionLabel:
                          fund.topEquitySectorDetail.topEquitySectorLabel,
                        firstHeading: 'Sector',
                        secondHeading: 'Fund',
                        indexHeading: fund.topEquitySectorDetail.indexName,
                        pieChartTableHeader: 'Fund Weighting (%)',
                        pieChartPrefix: 'The top sectors for this fund are',
                        asOfDate:
                          fund.topEquitySectorDetail.topEquitySectorAsOfDate,
                        details: 'topEquitySectors',
                      }}
                      fund={fund.topEquitySectorDetail}
                    />
                  )}

                {isPresented(fund, 'topCountryDetail') &&
                  fund.topCountryDetail && (
                    <PortfolioTopBaseComponent
                      meta={{
                        topLevelId: 'top-countries',
                        sectionLabel: fund.topCountryDetail.topCountryLabel,
                        firstHeading: 'Country',
                        secondHeading: isEtfIndex ? 'Weight (%)' : 'Fund',
                        indexHeading: fund.topCountryDetail.primaryIndex,
                        pieChartTableHeader: isEtfIndex
                          ? 'Country Weighting (%)'
                          : 'Fund Weighting (%)',
                        pieChartPrefix: `The top countries for this ${
                          isEtfIndex ? 'index' : 'fund'
                        } are`,
                        asOfDate: fund.topCountryDetail.topCountryAsOfDate,
                        details: 'topCountries',
                      }}
                      fund={fund.topCountryDetail}
                    />
                  )}

                {fund.topTenComponentDetail && (
                  <PortfolioTopBaseComponent
                    meta={{
                      topLevelId: 'top-components',
                      sectionLabel:
                        fund.topTenComponentDetail.topTenComponentLabel,
                      firstHeading: 'Company',
                      secondHeading: 'Weight (%)',
                      indexHeading: fund.topTenComponentDetail.primaryIndex,
                      pieChartTableHeader: 'Company Weighting (%)',
                      pieChartPrefix: `The top companies for this ${
                        isEtfIndex ? 'index' : 'fund'
                      } are`,
                      asOfDate:
                        fund.topTenComponentDetail.topTenComponentAsOfDate,
                      details: 'topComponents',
                    }}
                    fund={fund.topTenComponentDetail}
                  />
                )}

                {isPresented(fund, 'topIndustryDetail') &&
                  fund.topIndustryDetail && (
                    <PortfolioTopBaseComponent
                      meta={{
                        topLevelId: 'top-industries',
                        sectionLabel: fund.topIndustryDetail.topIndustryLabel,
                        firstHeading: 'Industry',
                        secondHeading: 'Fund',
                        indexHeading: fund.topIndustryDetail.primaryIndex,
                        pieChartTableHeader: 'Fund Weighting (%)',
                        pieChartPrefix: 'The top industries for this fund are',
                        asOfDate: fund.topIndustryDetail.topIndustryAsOfDate,
                        details: 'topIndustries',
                      }}
                      fund={fund.topIndustryDetail}
                    />
                  )}

                {isPresented(fund, 'assetAllocationDetail') &&
                  fund.assetAllocationDetail && (
                    <PortfolioTopBaseComponent
                      meta={{
                        topLevelId: 'asset-allocation',
                        sectionLabel:
                          fund.assetAllocationDetail.assetAllocationslabel,
                        firstHeading: 'Asset Class',
                        secondHeading: 'Fund',
                        indexHeading: null,
                        pieChartTableHeader: 'Fund Weighting (%)',
                        pieChartPrefix:
                          "The fund's top assets are comprised of",
                        asOfDate:
                          fund.assetAllocationDetail.assetAllocationsAsOfDate,
                        details: 'assetAllocations',
                      }}
                      fund={fund.assetAllocationDetail}
                    />
                  )}

                {isPresented(fund, 'topCurrencyDetail') &&
                  fund.topCurrencyDetail && (
                    <PortfolioTopBaseComponent
                      meta={{
                        topLevelId: 'top-currencies',
                        sectionLabel: fund.topCurrencyDetail.label,
                        firstHeading: 'Currency',
                        secondHeading: 'Fund',
                        indexHeading: fund.topCurrencyDetail.primaryIndex,
                        pieChartTableHeader: 'Fund Weighting (%)',
                        pieChartPrefix: 'The top currencies for this fund are',
                        asOfDate: fund.topCurrencyDetail.asOfDate,
                        details: 'topCurrencies',
                      }}
                      fund={fund.topCurrencyDetail}
                    />
                  )}

                {isPresented(fund, 'topBondSectorDetail') &&
                  fund.topBondSectorDetail && (
                    <PortfolioTopBaseComponent
                      meta={{
                        topLevelId: 'top-bond-sectors',
                        sectionLabel:
                          fund.topBondSectorDetail.topBondSectorLabel,
                        firstHeading: 'Sector',
                        secondHeading: 'Fund',
                        indexHeading: fund.topBondSectorDetail.indexName,
                        pieChartTableHeader: 'Fund Weighting (%)',
                        pieChartPrefix: 'The top sectors for this fund are',
                        asOfDate:
                          fund.topBondSectorDetail.topBondSectorAsOfDate,
                        details: 'topBondSectors',
                      }}
                      fund={fund.topBondSectorDetail}
                    />
                  )}

                {isPresented(fund, 'creditRatingDetail') &&
                  fund.creditRatingDetail &&
                  fund.creditRatings && (
                    <PortfolioBarChart
                      meta={{
                        tableId: 'credit-ratings-table',
                        sectionLabel: fund.creditRatingDetail.creditRatingLabel,
                        headingLabel: 'Rating',
                        asOfDate: fund.creditRatingDetail.creditRatingAsOfDate,
                        disclosure: fund.creditRatings.creditRatingDisclosure,
                        disclosureTitle: 'Credit Rating Disclosure',
                        details: 'creditRatings',
                      }}
                      fund={fund.creditRatingDetail}
                    />
                  )}

                {isPresented(fund, 'averageLifeDistrDetail') &&
                  fund.averageLifeDistributionDetail && (
                    <PortfolioBarChart
                      meta={{
                        tableId: 'average-life-distribution-table',
                        sectionLabel:
                          fund.averageLifeDistributionDetail
                            .averageLifeDistrLabel,
                        headingLabel: 'Maturity',
                        asOfDate:
                          fund.averageLifeDistributionDetail
                            .averageLifeDistrAsOfDate,
                        disclosure: '',
                        disclosureTitle: '',
                        details: 'averageLifeDistributions',
                      }}
                      fund={fund.averageLifeDistributionDetail}
                    />
                  )}
              </>
            )}
          </div>
        </div>
      </section>
    )
  }
}
PortfolioDetails.propTypes = {
  fund: PropTypes.object,
  fullHoldings: PropTypes.object,
}

export default PortfolioDetails
